var getPrimaryColorInfo = function (primaryColor, colors) {
  return {
    name: primaryColor,
    value: colors[primaryColor + "9"],
    token: "$" + primaryColor + "9",
    helpers: {
      pickScale: function (scale, options) {
        if (options === void 0) {
          options = {
            alpha: false
          };
        }
        return "$" + primaryColor + (options.alpha ? 'A' : '') + scale;
      }
    }
  };
};

export { getPrimaryColorInfo as default };
